var React = require('react');

function TickMarkCircle (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"28","height":"28","rx":"14","fill":"currentColor","key":0}),React.createElement("path",{"d":"M7.5 15.5488L10.234 19.0648C10.326 19.183 10.4433 19.2791 10.5774 19.3458C10.7114 19.4126 10.8587 19.4484 11.0085 19.4506C11.1582 19.4528 11.3066 19.4214 11.4425 19.3586C11.5785 19.2958 11.6986 19.2033 11.794 19.0878L20.5 8.54883","stroke":"white","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

TickMarkCircle.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 28 28","fill":"none"};

module.exports = TickMarkCircle;

TickMarkCircle.default = TickMarkCircle;
